import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturKollerhube() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-kollerhube-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-kollerhube-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="kollerhube" />
      </div>
    </div>
  );
}

export default BodentemperaturKollerhube;
